import React from 'react';
import Menu from '../components/Menu.js';
import '../styles/index.css';
import '../styles/archive.css';

export default function Archive() {
	let json = require('../ImageData.json');
	
	return(
		<div className="archive">
			<Menu />
			<div className="imgs">
				{json.map((elt) => {
					console.log(elt)
				  return (
			    	<div className="imgs-item">
				        <img
				          src={require('/public/compressed/' + elt)}
				        />
				    </div>
				  );
				})}
			</div>
			<div>
				<a href="https://instagram.com/erye.film" target="_blank" className="ig-icon">
					<img 
						alt={'Instagram logo'}
						src={require('../img/ig.png')}
					/>
				</a>
			</div>
		</div>
	)
} 

